module.exports = "/_next/static/images/banner-518585f44f5b42216d0226451027cd0e.jpeg";